import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default function(WrappedComponent) {
  class Container extends Component {
    static displayName = 'MySearchesSaveModalContainer'

    static propTypes = {
      done: PropTypes.bool.isRequired,
      error: PropTypes.bool.isRequired,
      handleSaveSearch: PropTypes.func.isRequired,
      open: PropTypes.bool.isRequired,
      pending: PropTypes.bool.isRequired,
      toggle: PropTypes.func.isRequired,
    }

    state = {
      name: '',
    }

    handleName = (e, { value }) => {
      this.setState({ name: value })
    }

    handleSubmit = e => {
      const { handleSaveSearch } = this.props
      const { name } = this.state

      e.preventDefault()
      handleSaveSearch(name)
    }

    render() {
      return <WrappedComponent handleName={this.handleName} handleSubmit={this.handleSubmit} {...this.props} {...this.state} />
    }
  }

  return Container
}
